import { motion } from "motion/react";

const NOISE =
  "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='160' height='160'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='2'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E";

/**
 * Rendered ONCE in App.tsx behind the deck. Blobs animate transform only
 * (GPU-composited); the blur filter itself is static. The noise overlay
 * prevents gradient banding on projectors.
 */
export function AuroraBackground() {
  return (
    <div aria-hidden className="pointer-events-none absolute inset-0 overflow-hidden">
      <motion.div
        className="absolute -left-[15%] -top-[20%] h-[55vw] w-[55vw] rounded-full opacity-25"
        style={{
          background: "radial-gradient(circle at center, #3b82f6 0%, transparent 62%)",
          filter: "blur(110px)",
        }}
        animate={{ x: [0, 90, -50, 0], y: [0, 60, 30, 0] }}
        transition={{ duration: 28, repeat: Infinity, ease: "easeInOut" }}
      />
      <motion.div
        className="absolute -bottom-[25%] -right-[15%] h-[50vw] w-[50vw] rounded-full opacity-20"
        style={{
          background: "radial-gradient(circle at center, #e879f9 0%, transparent 62%)",
          filter: "blur(120px)",
        }}
        animate={{ x: [0, -80, 40, 0], y: [0, -50, -20, 0] }}
        transition={{ duration: 32, repeat: Infinity, ease: "easeInOut" }}
      />
      <motion.div
        className="absolute left-[30%] top-[35%] h-[40vw] w-[40vw] rounded-full opacity-15"
        style={{
          background: "radial-gradient(circle at center, #22d3ee 0%, transparent 62%)",
          filter: "blur(130px)",
        }}
        animate={{ x: [0, 60, -60, 0], y: [0, -70, 40, 0] }}
        transition={{ duration: 24, repeat: Infinity, ease: "easeInOut" }}
      />
      <div
        className="absolute inset-0 opacity-[0.04]"
        style={{ backgroundImage: `url("${NOISE}")` }}
      />
    </div>
  );
}
